import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { Message } from 'element-ui';
import IconButton from '../../common/IconButton.vue';
import TUIRoomCore, { ETUIRoomEvents, ETUIRoomRole } from '../../../tui-room-core';
import { useBasicStore } from '@/stores/basic';
import { StreamInfo, useRoomStore } from '@/stores/room';
import logger from '../../../tui-room-core/common/logger/logs';
import SvgIcon from '../../common/SvgIcon.vue';
import { ICON_NAME } from '../../../../constants/icon';
import { MESSAGE_DURATION } from '../../../../constants/message';
import { LIVE_STAGE } from '@/constants/room';
import {LAYOUT} from "@/constants/render";
import StringUtils from "@/putils/StringUtils";
import {USER_ROLE_MAJOR} from "@/constants/localKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const logPrefix = '[ScreenShareControl]';

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const { localStream, remoteUserObj } = storeToRefs(roomStore);
const { shareUserId, sharingStatus, shareUserSig, isAudience, role, screenProfile,liveStageRoom,userRole,userName,userAvatar } = storeToRefs(basicStore);
const showScreenShareIcon = computed(() => shareUserId.value && shareUserSig?.value);

const btnStopRef = ref();
const isSharing: Ref<boolean> = ref(sharingStatus);
const showStopShareRegion: Ref<boolean> = ref(false);
const dialogVisible: Ref<boolean> = ref(false);

const title = computed(() => (sharingStatus.value ? '屏幕共享中' : '共享屏幕'));
const iconName = computed(() => {
  if (isAudience.value) {
    return ICON_NAME.ScreenShareDisabled;
  }
  return isSharing.value ? ICON_NAME.ScreenSharing : ICON_NAME.ScreenShare;
});

watch(role, (val: any, oldVal: any) => {
  if (oldVal === ETUIRoomRole.ANCHOR && val === ETUIRoomRole.AUDIENCE && isSharing.value) {
    stopScreenShare();
  }

});
watch(sharingStatus, (newValue, oldValue) => {
  console.log("new", newValue, "old", oldValue);
  if(oldValue==true){
    showStopShareRegion.value = false;
  }
});

onMounted(() => {
  TUIRoomCore.on(ETUIRoomEvents.onWebScreenSharingStopped, stopScreenShare);
});

onUnmounted(() => {
  TUIRoomCore.off(ETUIRoomEvents.onWebScreenSharingStopped, stopScreenShare);
});

async function toggleScreenShare() {
  //todo 共享屏幕
  if (liveStageRoom.value != LIVE_STAGE.ONGOING){
    // Message({
    //   type: 'warning',
    //   message: '直播暂未开始， 不能共享屏幕',
    //   duration: MESSAGE_DURATION.LONG,
    // });
    // return;
  }

  if (isAudience.value) {
    Message({
      type: 'warning',
      message: '您当前没有共享权限，请先举手申请上台获取共享权限',
      duration: MESSAGE_DURATION.LONG,
    });
    return;
  }

  if (localStream.value.isGrantAnchor == false && !StringUtils.isObjEqual(userRole.value,USER_ROLE_MAJOR)){
    Message({
      type: 'warning',
      message: '您当前不是主讲人，不能共享屏幕',
      duration: MESSAGE_DURATION.LONG,
    });
    return;
  }

  if (isSharing.value) {
    showStopShareRegion.value = true;
    return;
  }

  try {
    const tuiResponse = await TUIRoomCore.startScreenShare({
      shareUserId: shareUserId.value,
      shareUserSig: shareUserSig?.value || '',
      screenProfile: screenProfile,
    });
    if (tuiResponse.code === 0) {
      isSharing.value = true;
      basicStore.setSharingStatus(true);
      roomStore.setRemoteScreenStream({userId:shareUserId.value,available:true})
      basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
    } else {
      logger.error(`${logPrefix}startScreenShare error: ${tuiResponse.code} ${tuiResponse.message}`);
      Message({
        type: 'warning',
        message: tuiResponse.message,
        duration: MESSAGE_DURATION.LONG,
      });
    }
  } catch (error: any) {
    logger.error(`${logPrefix}startScreenShare error:`, error);
    throw error;
  }
}

function openStopConfirmDialog() {
  console.log('我结束的共享屏幕');
  showStopShareRegion.value = false;

  roomStore.setRemoteScreenStream({userId:shareUserId.value,available:false})
  if (isSharing.value) {
    dialogVisible.value = true;
  }
}

function cancelStop() {
  dialogVisible.value = false;
}

async function stopScreenShare() {
  if (isSharing.value) {
    try {
      await TUIRoomCore.stopScreenShare({
        shareUserId: shareUserId.value,
        shareUserSig: shareUserSig?.value || '',
        screenProfile: screenProfile,
      });
      dialogVisible.value = false;
      isSharing.value = false;
      basicStore.setSharingStatus(false);
      roomStore.setRemoteScreenStream({userId:shareUserId.value,available:false})
      if (!StringUtils.isObjEqual(userRole,USER_ROLE_MAJOR)) {
        basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
      }
    } catch (error) {
      logger.error(`${logPrefix}stopScreenShare error:`, error);
    }
  }
}


return { __sfc: true,logPrefix, basicStore, roomStore, localStream, remoteUserObj, shareUserId, sharingStatus, shareUserSig, isAudience, role, screenProfile, liveStageRoom, userRole, userName, userAvatar, showScreenShareIcon, btnStopRef, isSharing, showStopShareRegion, dialogVisible, title, iconName, toggleScreenShare, openStopConfirmDialog, cancelStop, stopScreenShare, IconButton, SvgIcon, ICON_NAME }
}

})